import { Flex, Progress } from "antd"
import { UploadText, CopyText, UploadImageText, ClearCacheText } from "./TextComponents"
import { processes } from "../../constants"

const { UPLOADING, COPYING } = processes

type Props = {
  progress: number
  message: string
  process: "uploading" | "copying" | "uploadingImage" | "cacheClearing"
  url?: string
  articleName?: string
  portalName?: string
  czUrl?: string
  czArticleName?: string
  isTextWrong?: boolean
  isError?: boolean
}

export const ProgressBar: React.FC<Props> = ({
  progress,
  message,
  process,
  url,
  articleName,
  czUrl,
  czArticleName,
  isTextWrong,
  isError = false,
}) => {
  const progressStatus = progress === 100 ? "success" : "active"
  const status = isError ? "exception" : progressStatus
  return (
    <Flex vertical style={{ marginTop: "15px" }}>
      {process === UPLOADING && (
        <UploadText message={message} url={url} articleName={articleName} />
      )}
      {process === COPYING && (
        <CopyText
          message={message}
          url={url}
          articleName={articleName}
          czUrl={czUrl}
          czArticleName={czArticleName}
          isTextWrong={isTextWrong}
        />
      )}
      {process === "uploadingImage" && (
        <UploadImageText message={message} imageName={articleName} />
      )}
      {process === "cacheClearing" && (
        <ClearCacheText message={message} portalName={articleName} />
      )}
      <Progress percent={progress} status={status} showInfo={false} />
    </Flex>
  )
}
